import Vue from "vue";
import Element from "element-ui";
// import "../element-variables.scss";
import "element-ui/lib/theme-chalk/index.css";
import ElSelectTree from 'el-select-tree';
Element.Dialog.props.closeOnClickModal.default = false; 
Vue.use(Element);
Vue.use(ElSelectTree);
